<template>
  <div>
    <p>Сумма в заявке <strong>{{ order.price }}</strong></p>
    <p>Реквизиты привязаны к заявке на сумму <strong>{{ order.no_cash_price }}</strong></p>
    <div class="alert alert-info">
      <p>Рекомендации</p>
      <ul>
        <li>установить скидку (в допустимых пределах) в заявке, чтобы суммы в реквизитах и сумма заявки были равны</li>
        <li>установить доставку (в допустимых пределах) в заявке, чтобы суммы в реквизитах и сумма заявки были равны</li>
        <li>привязать новые реквизиты с действующей суммой заявки</li>
      </ul>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['order'],
  components: {},
  data() {
    return {}
  }
}
</script>
